import React from 'react';

import classNames from 'classnames';

const statusClassName = {
  grey: 'tw-text-grey-600 tw-bg-grey-200',
  high: 'tw-text-white tw-bg-red-500',
  low: 'tw-text-white tw-bg-green-400',
  medium: 'tw-text-grey-900 tw-bg-amber-300',
};

export default function InfoBlock({ isDisabled, status, value }) {
  return (
    <div
      className={classNames(
        'info-block tw-text-xs tw-font-semibold tw-tracking-wide',
        statusClassName[status],
        isDisabled && 'tw-opacity-30',
      )}
    >
      {value}
    </div>
  );
}
